import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { SubmittedStoriesCard } from './SubmittedStoriesCard';
import IssuesCard from './IssuesCard';
import { getRecentActivity, searchIssues, useAuthState } from '../../components';
import { getSearchCriteria } from '../IssueSearchCriteria';
import SceneCard from '../../player/overview/SceneCard';
import { listScenes } from '../../components/sceneRequests';
import { EventsCard, getEventData } from '../../player/overview/EventsCard';
import { getWhoList, WhoCard } from '../../player/overview/WhoCard';

function BuilderOverview() {

    const { currentUser } = useAuthState();

    const [whosOnline, setWhosOnline] = useState([]);
    const [realmEvents, setRealmEvents] = useState([]);
    const [futureEvents, setFutureEvents] = useState([]);
    const [builderIssues, setBuilderIssues] = useState([]);
    const [recentIssues, setRecentIssues] = useState([]);
    const [recentStories, setRecentStories] = useState([]);
    const [scenes, setScenes] = useState([]);

    useEffect(() => {
        getWhoList(setWhosOnline);
        getRecentActivityData();
        getBuilderIssues();
        getScenesFromServer();
        getEventData(setRealmEvents, setFutureEvents);

        const intervalRefreshFast = setInterval(() => {
            getWhoList(setWhosOnline);
        }, 60000);


        const intervalRefresh = setInterval(() => {
            getRecentActivityData();
            getBuilderIssues();
            getEventData(setRealmEvents, setFutureEvents);
        }, 600000);

        return () => {
            clearInterval(intervalRefresh);
            clearInterval(intervalRefreshFast);
        }

    }, []);

    const getRecentActivityData = async () => {
        let data = await getRecentActivity();
        if (data.result) {
            data.issues.sort((a, b) => b.issue_updated - a.issue_updated);
            setRecentIssues(data.issues);
            setRecentStories(data.stories)
        } else {
            setRecentIssues([]);
            setRecentStories([])
        }
    }

    const getBuilderIssues = async () => {
        let issueSearch = getSearchCriteria('MYOPEN', 'Bug', '', '', currentUser);
        let data = await searchIssues(issueSearch);
        if (data.result) {
            setBuilderIssues(data.issues);
        } else {
            setBuilderIssues([]);
        }
    }

    const getScenesFromServer = async e => {
        const data = await listScenes();
        if (data.result) {
            setScenes(data.scenes);
        } else {
            setScenes([]);
        }
    }


    return (
        <div className="container container-wide" id="divMainContent">
            <div style={{
                display: 'flex', flex: 1, flexDirection: 'row', flexWrap: 'wrap', alignItems: "flex-start",
                justifyContent: "space-around"
            }}>
                <Row>
                    <Col xl={4}>
                        <WhoCard whosOnline={whosOnline} />
                        <EventsCard title={"Active"} mudEvents={realmEvents} />
                        <EventsCard title={"Future"} mudEvents={futureEvents} />
                        <SceneCard scenes={scenes} />
                    </Col>
                    <Col xl={4}>
                        <SubmittedStoriesCard stories={recentStories} />
                        <IssuesCard title={"Recently Updated Issues"} issues={recentIssues} />
                    </Col>
                    <Col xl={4}>
                        <IssuesCard title={"My Bugs"} issues={builderIssues} />
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default BuilderOverview;